// Cliente HTTP para a API própria; substituição gradual dos serviços Firebase.
const request = async (path, options={}) => {
  const response=await fetch('/api'+path,{
    credentials:'same-origin',
    headers:{'Content-Type':'application/json',...(options.headers||{})},
    ...options
  });
  const result=await response.json().catch(()=>({error:'Resposta inválida da API'}));
  if(!response.ok)throw Object.assign(new Error(result.error||'Erro na API'),{status:response.status});
  return result;
};
export const domusApi={
  health:()=>request('/healthz'),
  register:body=>request('/auth/register',{method:'POST',body:JSON.stringify(body)}),
  login:(email,password)=>request('/auth/login',{method:'POST',body:JSON.stringify({email,password})}),
  googleLogin:credential=>request('/auth/google',{method:'POST',body:JSON.stringify({credential})}),
  me:()=>request('/auth/me'),
  logout:()=>request('/auth/logout',{method:'POST'}),
  families:()=>request('/families'),
  createFamily:name=>request('/families',{method:'POST',body:JSON.stringify({name})}),
  familyMembers:familyId=>request('/families/'+encodeURIComponent(familyId)+'/members'),
  sosList:familyId=>request('/families/'+encodeURIComponent(familyId)+'/sos'),
  sosSend:(familyId,message,location=null)=>request('/families/'+encodeURIComponent(familyId)+'/sos',{method:'POST',body:JSON.stringify({message,location})}),
  sosAck:(familyId,id)=>request('/families/'+encodeURIComponent(familyId)+'/sos/'+encodeURIComponent(id)+'/ack',{method:'POST'}),
  sosResolve:(familyId,id)=>request('/families/'+encodeURIComponent(familyId)+'/sos/'+encodeURIComponent(id)+'/resolve',{method:'POST'}),
  inviteMember:(familyId,email)=>request('/families/'+encodeURIComponent(familyId)+'/invitations',{method:'POST',body:JSON.stringify({email})}),
  proposals:familyId=>request('/families/'+encodeURIComponent(familyId)+'/proposals'),
  propose:(familyId,proposal)=>request('/families/'+encodeURIComponent(familyId)+'/proposals',{method:'POST',body:JSON.stringify(proposal)}),
  decideProposal:(familyId,id,decision)=>request('/families/'+encodeURIComponent(familyId)+'/proposals/'+encodeURIComponent(id)+'/decision',{method:'POST',body:JSON.stringify({decision})}),
  joinFamily:code=>request('/families/join',{method:'POST',body:JSON.stringify({code})}),
  records:(familyId,type)=>request('/families/'+encodeURIComponent(familyId)+'/records?type='+encodeURIComponent(type)),
  createRecord:(familyId,type,payload)=>request('/families/'+encodeURIComponent(familyId)+'/records',{method:'POST',body:JSON.stringify({type,payload})}),
  updateRecord:(familyId,id,payload)=>request('/families/'+encodeURIComponent(familyId)+'/records/'+encodeURIComponent(id),{method:'PATCH',body:JSON.stringify({payload})}),
  deleteRecord:(familyId,id)=>request('/families/'+encodeURIComponent(familyId)+'/records/'+encodeURIComponent(id),{method:'DELETE'})
};
